module.exports = __webpack_public_path__ + "static/media/vehicle.4ea5cd09.svg";